import { render } from "./MeetingArchiveWrapper.vue?vue&type=template&id=5e89657f&scoped=true"
import script from "./MeetingArchiveWrapper.vue?vue&type=script&lang=js"
export * from "./MeetingArchiveWrapper.vue?vue&type=script&lang=js"

import "./MeetingArchiveWrapper.vue?vue&type=style&index=0&id=5e89657f&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e89657f"]])

export default __exports__